module.exports = __webpack_public_path__ + "img/ss.fff56042.svg";